if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    /* 2026-10-26: the form, button and id input are looked up when they are needed, not in the constructor.
       A product form that is created before its inner markup exists (a copied slider card, or one built while the
       page is still loading) used to throw "Cannot read properties of null" and stop the page's other scripts. */
    constructor() {
      super();
      this.hideErrors = this.dataset.hideErrors === 'true';
      this._wired = false;
      this._onSubmit = this.onSubmitHandler.bind(this);
    }

    connectedCallback() {
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (this._wire()) return;
      const retry = () => { this._wire(); };
      requestAnimationFrame(retry);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', retry, { once: true });
    }

    _wire() {
      if (this._wired) return true;
      const form = this.querySelector('form');
      if (!form) return false;
      this._wired = true;
      const idInput = form.querySelector('[name=id]');
      if (idInput) idInput.disabled = false;
      form.addEventListener('submit', this._onSubmit);
      const button = this.submitButton;
      if (button && document.querySelector('cart-drawer')) button.setAttribute('aria-haspopup', 'dialog');
      return true;
    }

    get form() { return this.querySelector('form'); }
    get submitButton() { return this.querySelector('[type="submit"]'); }
    get submitButtonText() { const b = this.submitButton; return b ? b.querySelector('span') : null; }
    get variantIdInput() { const f = this.form; return f ? f.querySelector('[name=id]') : null; }

    _spinner() { return this.querySelector('.loading-overlay__spinner'); }

    clearButtonLoading() {
      const button = this.submitButton;
      if (button) button.classList.remove('loading');
      const spinner = this._spinner();
      if (spinner) spinner.classList.add('hidden');
      if (!this.error && button) button.removeAttribute('aria-disabled');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const button = this.submitButton;
      if (!button || !this.form) return;
      if (button.getAttribute('aria-disabled') === 'true') return;
      if (!this.cart) this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      this.handleErrorMessage();

      button.setAttribute('aria-disabled', true);
      button.classList.add('loading');
      const spinner = this._spinner();
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = button.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            button.setAttribute('aria-disabled', true);
            const label = button.querySelector('span');
            if (label) label.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id'), cartData: response});
          this.error = false;
          this.clearButtonLoading();

          const quickAddModal = this.closest('quick-add-modal');
          const cartDrawer = document.querySelector('cart-drawer');
          const useFlyToCart =
            window.theme &&
            window.theme.enableFlyToCart &&
            cartDrawer &&
            this.cart === cartDrawer &&
            !this.closest('.wbcartupsell') &&
            window.ThemeCartFlyToCart &&
            typeof window.ThemeCartFlyToCart.play === 'function';

          const runCartContents = () => {
            if (useFlyToCart) {
              window.ThemeCartFlyToCart.play({
                cartDrawer,
                parsedState: response,
                productForm: this,
                quickAddOpener: quickAddModal ? quickAddModal.openedBy : null,
                openDrawer: window.theme.flyDrawer,
                onFlyComplete: () => {
                  if (!window.theme.flyDrawer && typeof cartDrawer.setHeaderStickyForDrawer === 'function') {
                    cartDrawer.setHeaderStickyForDrawer(false);
                  }
                },
              });
            } else {
              this.cart.renderContents(response);
            }
          };

          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(runCartContents);
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            runCartContents();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (button.classList.contains('loading')) {
            this.clearButtonLoading();
          }
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      const button = this.submitButton;
      if (!button) return;
      const label = this.submitButtonText;
      if (disable) {
        button.setAttribute('disabled', 'disabled');
        if (text && label) label.textContent = text;
      } else {
        button.removeAttribute('disabled');
        if (label) label.textContent = window.variantStrings.addToCart;
      }
    }
  });
}
